// Blog post registry — add new posts here
// Content is written as React components to avoid MDX build tooling

export const posts = [
  {
    slug: 'step-5-golden-boot-race-2025-26',
    title: 'The Step 5 Golden Boot Race: 352 Players, 15 Leagues, and the Strikers the Pyramid Is Missing',
    description: 'Lewis-Simon Byrne leads the tracked Step 5 field with 57 goals, but the deeper story is the chasing pack: Jack Arnold, Luke Burrows, Lee Cox, Ross Davis and the scorers turning local tables into recruitment signals.',
    seoTitle: 'Step 5 Golden Boot Race 2025-26 | Non-League Strikers',
    seoDescription: 'The Step 5 Golden Boot race across 15 tracked leagues: Lewis-Simon Byrne, Jack Arnold, Luke Burrows, Lee Cox, Ross Davis and the non-league strikers scouts should know.',
    date: '2026-04-21',
    author: 'Below The Radar',
    kicker: 'Data Watch',
    tags: ['step-5', 'data', 'golden-boot', 'non-league', 'scouting', 'analytics'],
    readingTime: 9,
    image: '/blog-step-5-golden-boot-race-non-league-strikers-2025-26.png',
  },
  {
    slug: 'nwcfl-goals-per-game-2025-26',
    title: 'The Most Dangerous Strikers in England You\'ve Never Heard Of: 2025-26 Goals Per Game Rankings',
    description: "Lewis-Simon Byrne now has 57 goals in 42 NWCFL appearances, while Ross Davis leads the sustained goals-per-game filter at 1.43. A data investigation into the non-league scorers hiding in plain sight.",
    seoTitle: 'Dangerous Non-League Strikers | 2025-26 Goals Per Game Rankings',
    seoDescription: 'A data-led look at the most dangerous non-league strikers in England, led by Lewis Byrne and the 2025-26 goals-per-game rankings below the EFL.',
    date: '2026-03-27',
    author: 'Below The Radar',
    tags: ['nwcfl', 'data', 'analytics', 'goals-per-game', 'non-league', 'player-watch'],
    readingTime: 7,
    image: '/blog-dangerous-non-league-strikers-goals-per-game-rankings-2025-26.png',
  },
  {
    slug: 'lewis-byrne-chadderton-53-goals',
    title: '57 Goals and Counting: How Lewis Byrne Broke the NWCFL Record at Chadderton',
    description: "Lewis-Simon Byrne has scored 57 goals in 42 appearances for Chadderton FC this season, extending the all-time NWCFL record. From Sunday league to record-breaker — the best striker you have never heard of.",
    date: '2026-03-24',
    author: 'Below The Radar',
    tags: ['nwcfl', 'player-watch', 'chadderton', 'goal-scorers', 'step-5'],
    readingTime: 8,
    image: '/blog-lewis-byrne-chadderton-53-goals.png',
  },
];

export function getPost(slug) {
  return posts.find(p => p.slug === slug) || null;
}

export function getAllPosts() {
  return [...posts].sort((a, b) => new Date(b.date) - new Date(a.date));
}
